module.exports = __webpack_public_path__ + "static/media/RanchWall.9a342a6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/RanchWall.jpg
// module id = 5783
// module chunks = 0